import 'core-js/modules/es.object.assign.js';
import { Button } from '../components/button/button.overrides.js';
import { ButtonGroup } from '../components/button-group/button-group.overrides.js';
import { InputLabel } from '../components/input-label/input-label.overrides.js';
import { InputBase } from '../components/input-base/input-base.overrides.js';
import { Chip } from '../components/chip/chip.overrides.js';
import { Alert } from '../components/alert/alert.overrides.js';
import { FormControl } from '../components/form-control/form-control.overrides.js';

const makeComponents = theme => Object.assign(Alert(), FormControl(), Button(theme), ButtonGroup(), InputLabel(theme), InputBase(), Chip(theme));

export { makeComponents };
